module.exports = __webpack_public_path__ + "static/media/savoirMag.20de1326.png";